import React, { PureComponent } from 'react';
import { bool } from 'prop-types';
import { CollapsePanel } from 'components';

export default class FilterCollapsePanel extends PureComponent {
    static propTypes = {
        openedByDefault: bool,
    };

    static defaultProps = {
        openedByDefault: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            opened: true,
        };

        this.useByUser = false;
    }

    componentDidMount() {
        if (!this.props.openedByDefault) {
            setTimeout(() => {
                if (!this.useByUser) {
                    this.setOpen(false);
                }
            }, 1000);
        }
    }

    setOpen = opened => {
        this.setState({ opened });
    };

    usedByUser = () => {
        this.useByUser = true;
    };

    render() {
        const { openedByDefault, ...otherProps } = this.props;

        return (
            <CollapsePanel
                opened={this.state.opened}
                onChange={this.setOpen}
                onClick={this.usedByUser}
                {...otherProps}
            />
        );
    }
}
